"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.error.create': 'Errore nella creazione del gruppo di utenti',
};
